import { render, staticRenderFns } from "./InstructionCardsList.vue?vue&type=template&id=35e59629&scoped=true"
import script from "./InstructionCardsList.vue?vue&type=script&lang=js"
export * from "./InstructionCardsList.vue?vue&type=script&lang=js"
import style0 from "./InstructionCardsList.vue?vue&type=style&index=0&id=35e59629&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e59629",
  null
  
)

export default component.exports